/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-12 15:32:10
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbCoupon {
    /**
     * 获取结算优惠券
     */
    export var GetSettlementCouponList = (body: any): Promise<any> => {
        return Post(`/api/TbCoupon/GetSettlementCouponList`, body);
    };
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbCoupon.ts